import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import SubmitButtonComponent from 'webapp/components/submit-button';

interface Args {
	skipAction?: (() => void) | null;
	continueAction: (() => void) | null;
	buttonText?: string;
	isButtonDisabled?: boolean;
}

interface OnboardingCommonBottomComponentInterface {
	Element: HTMLDivElement;
	Blocks: { default: [] };
	Args: Args;
}

export default class OnboardingCommonBottomComponent extends Component<OnboardingCommonBottomComponentInterface> {
	get buttonText() {
		return `${this.args.buttonText || 'Continue'} &gt;`;
	}

	get isButtonDisabled() {
		return this.args.isButtonDisabled || false;
	}

	get buttonExtraClass() {
		const extraClass = ['action', 'action--continue'];

		if (this.isButtonDisabled) {
			extraClass.push('disabled');
		}
		return extraClass.join(' ');
	}

	@action
	continue() {
		if (this.args.continueAction) {
			this.args.continueAction();
		}
	}

	@action
	skipAction() {
		if (this.args.skipAction) {
			this.args.skipAction();
		}
	}
	<template>
		<div class="onboarding-bottom smart-center-pos">
			<div class="container">
				<div class="onboarding-bottom__actions">
					<div class="onboarding-bottom__actions-container">
						<SubmitButtonComponent
							@text={{this.buttonText}}
							@size="big"
							@noDelay={{true}}
							@onTrigger={{this.continue}}
							@extraClass={{this.buttonExtraClass}}
						/>
					</div>
					{{#if @skipAction}}
						<a {{on "click" this.skipAction}} class="action action--skip">
							Skip
							<span class="desktop">and go to app</span>
						</a>
					{{/if}}
					{{yield}}
				</div>
			</div>
		</div>
	</template>
}
